module.exports = __webpack_public_path__ + "8a3c2220cbeaabe3c38653ce7c960709.png";